mutation GeneratePurchaseOrderIntegration($input: GenerateIntegrationInput!) {
  generatePurchaseOrderIntegration(input: $input) {
    integrationDocumentId
  }
}
